import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMH = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 50c13.807 0 25-11.193 25-25a24.89 24.89 0 0 0-2.861-11.621L24.97 25.029 36.62 2.862A24.89 24.89 0 0 0 25 0C11.193 0 0 11.193 0 25a24.922 24.922 0 0 0 7.322 17.678A24.921 24.921 0 0 0 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M47.113 13.406a24.993 24.993 0 0 0-4.464-6.055 24.987 24.987 0 0 0-6.054-4.463L7.294 42.706l39.819-29.3Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "m7.294 42.706 39.819-29.3a24.993 24.993 0 0 0-4.464-6.055L7.294 42.706Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m21.709 14.66-3.053 1.436 1.626 2.958-3.316-.635-.42 3.35-2.31-2.464-2.309 2.463-.42-3.349-3.315.634 1.626-2.957-3.053-1.436 3.053-1.436-1.626-2.957 3.315.634.42-3.349 2.31 2.464 2.31-2.464.42 3.35 3.315-.635-1.626 2.957 3.053 1.436Z"
}));
FlagMH.displayName = 'FlagMH';
export default withFlagWrapper(FlagMH);
//# sourceMappingURL=index.js.map